import { render, staticRenderFns } from "./PersEdit.vue?vue&type=template&id=56acef3f&scoped=true"
import script from "./PersEdit.vue?vue&type=script&lang=js"
export * from "./PersEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56acef3f",
  null
  
)

export default component.exports